import { apiFactory } from '../ApiFactory';

export type CreateMemberDto = {
	name: string;
	email: string;
	phone: string;
};

type AccessTokenResponse = { id: number; access_token: string };

const create = async (data: CreateMemberDto) => {
	const client = await apiFactory.getInstance().getCurseducaProfClient();

	return client.post<AccessTokenResponse>('/user', data);
};

// Sem `GET /user-access-token`: o prof removeu a rota em 20/10 (emitia token
// de qualquer membro só pelo e-mail) e ela não pode voltar.

export const membersApi = {
	create
};
